// extracted by mini-css-extract-plugin
module.exports = {"pageRoot":"pageWrapper_pageRoot__2rlxp","contentWrap":"pageWrapper_contentWrap__1PuA3","content":"pageWrapper_content__xARk1","contentActions":"pageWrapper_contentActions__rPEfU"};